export default function calcDeg(s) {
  let deg;

  /**
   * 5mbps --------> 31°
   * 10mbps -------> 61°
   * 15mbps -------> 91°
   * 25mbps ------> 121°
   * 50mbps ------> 151°
   * 100mbps -----> 179°
   * 300mbps -----> 210°
   * 500mbps -----> 240°
   * 1000mbps ----> 260°
   */
  if (s < 5) {
    deg = s * (31 / 5);
  } else if (s < 10) {
    deg = 31;
    deg += (s - 5) * ((61 - 31) / (10 - 5));
  } else if (s < 15) {
    deg = 61;
    deg += (s - 10) * ((91 - 61) / (15 - 10));
  } else if (s < 25) {
    deg = 91;
    deg += (s - 15) * ((121 - 91) / (25 - 15));
  } else if (s < 50) {
    deg = 121;
    deg += (s - 25) * ((151 - 121) / (50 - 25));
  } else if (s < 100) {
    deg = 151;
    deg += (s - 50) * ((179 - 151) / (100 - 50));
  } else if (s < 300) {
    deg = 179;
    deg += (s - 100) * ((210 - 179) / (300 - 100));
  } else if (s < 500) {
    deg = 210;
    deg += (s - 300) * ((240 - 210) / (500 - 300));
  } else if (s < 1000) {
    deg = 240;
    deg += (s - 500) * ((266 - 240) / (1000 - 500));
  } else {
    deg = 266;
  }

  return Math.round(deg);
}



// WEBPACK FOOTER //
// ./src/js/lib/calc-deg.js